;"use strict";
window.overwatch = window.overwatch || {};

window.overwatch.PrimaryRetailerModel = {

	Mediator: null,

	eventNameChange: null,

	retailerMap: null,

	currentRetailer: null,

	platformMap: null,

	$doc: $(document),

	init: function(config) {
		var self = this;

		this.eventNameChange = config.eventNameChange;
		this.retailerMap = config.retailerMap;
		this.currentRetailer = config.currentRetailer;
		this.platformMap = config.platformMap;
		this.Mediator = config.Mediator;
	},

	getCurrentRetailer: function() {
		return this.currentRetailer;
	},

	setCurrentRetailerByPlatformAndSkuIdAndCountryCode: function(platform, skuId, countryCode) {
		var newRetailer = null;
		var retailerName = this.platformMap[platform].shopName || this.platformMap[platform].name;
		var retailer = this.retailerMap[platform] || {};
		var href = this._getRetailerUrl(retailer, skuId, countryCode);
		if (href) {
			newRetailer = {
				name: retailerName,
				platform: retailer.platform,
				href: href
			};
		}
		this.setCurrentRetailer(newRetailer);
	},

	setCurrentRetailer: function(retailer) {
		this.currentRetailer = retailer;
		this._publish();
	},

	_getRetailerUrl: function(retailer, skuId, countryCode) {
		var url = null;
		if (skuId === "ORIGINS" && retailer.countryLinkOrigins && retailer.countryLinkOrigins[countryCode]) {
			url = retailer.countryLinkOrigins[countryCode];
		} else if (skuId === "BASIC" && retailer.countryLinkBasic && retailer.countryLinkBasic[countryCode]) {
			url = retailer.countryLinkBasic[countryCode];
		} else if (skuId === "COLLECTORS" && retailer.countryLinkCollectors && retailer.countryLinkCollectors[countryCode]) {
			url = retailer.countryLinkCollectors[countryCode];
		} else if (retailer.skuLinks) {
			url = retailer.skuLinks[skuId];
		}
		return url;
	},

	_publish: function() {
		this.Mediator.publish(this.eventNameChange, this.currentRetailer);
	}

};

window.overwatch.SecondaryRetailerModel = {

	Mediator: null,

	eventNameChange: null,

	retailerMap: null,

	currentRetailers: null,

	$doc: $(document),

	init: function(config) {
		var self = this;

		this.Mediator = config.Mediator;
		this.eventNameChange = config.eventNameChange;
		this.retailerMap = config.retailerMap;
		this.currentRetailers = config.currentRetailers || [];
	},

	getCurrentRetailers: function() {
		return this.currentRetailers;
	},

	setCurrentRetailersByCountryCodeAndSkuIdAndPlatform: function(countryCode, skuId, platform) {
		var retailers = this.retailerMap[countryCode] || [];

		retailers = retailers
			.filter(function filterPlatform(retailer) {
				// either platform matches OR platform isn't specific (unspecified = all platforms)
				return retailer.platform === null || retailer.platform === platform;
			})
			.filter(function removeUnsupportedSku(retailer) {
				var href = retailer.skuLinks[skuId];
				return href !== undefined;
			})
			.map(function simpleRetailerTransform(retailer) {
				return {
					name: retailer.name,
					href: retailer.skuLinks[skuId]
				};
			});

		if (retailers.length === 0) {
			retailers = null;
		}

		this.setCurrentRetailers(retailers);
	},

	setCurrentRetailers: function(retailers) {
		this.currentRetailers = retailers;
		this._publish();
	},

	_publish: function() {
		this.Mediator.publish(this.eventNameChange, this.currentRetailers);
	}

};
